import Controller from "@ember/controller";
import { tracked } from "@glimmer/tracking";
export default class LoginSsoController extends Controller {
  queryParams = ["code"];
  @tracked code: string | undefined;
}
